export default __webpack_public_path__ + "static/media/character-shigetane.b8ed0134.png";